module.exports = __webpack_public_path__ + "static/media/19.Ultra R6-双页-中文.e0e1fa7b.jpg";